<template>
    <div class="panel-container">
        <button class="unstyled-button close-button" @click="this.$router.push('/projects')">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="#051C2E">
                <path d="M6.4 18.65 5.35 17.6l5.6-5.6-5.6-5.6L6.4 5.35l5.6 5.6 5.6-5.6 1.05 1.05-5.6 5.6 5.6 5.6-1.05 1.05-5.6-5.6Z"/>
            </svg>
        </button>
        <div v-if="loading" class="sk-circle-container">
            <div class="sk-circle">
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
                <div class="sk-circle-dot"></div>
            </div>
        </div>
        <div v-else id="keys-panel-text">
            <h2>Authentication keys</h2>
            <p><b>Project number: </b>{{ prjnum }}</p>
            <KeyGeneration 
                :prjnum="prjnum"
                :keyCount="keyData.length"
                @key-generated="getKeyData(false)"
            /> <!---limit on all keys, not just available--->
            <div v-if="!loadError" class="key-container">
                <h3>Available keys</h3>
                <div v-if="validKeyData.length != 0" class="spaced">
                    <AccessKey v-for="key in validKeyData"
                        valid
                        :prjnum="prjnum"
                        :key="key.access_key"
                        :access_key="key.access_key"
                        :key_desc="key.user_note"
                        :expire="key.expire"
                        @open-key="openKey"
                    />
                </div>
                <p v-else class="spaced">There are no keys to show.<br /><br />The keys you generate will appear in this list.</p>
                <h3>Expired keys</h3>
                <div v-if="expiredKeyData.length != 0" class="spaced">
                    <AccessKey v-for="key in expiredKeyData"
                        :valid="false"
                        :prjnum="prjnum"
                        :key="key.access_key"
                        :access_key="key.access_key"
                        :key_desc="key.user_note"
                        :expire="key.expire"
                    />
                </div>
                <p v-else class="spaced">The are no expired keys to show.</p> 
            </div>
            <div v-else class="key-container"><p>Error loading access keys</p></div>
            <DeletionModal /> 
        </div>
    </div>
</template>

<script>


import axios from "axios";
import AccessKey from './AccessKey.vue';
import KeyGeneration from './KeyGeneration.vue';
import DeletionModal from './DeletionModal';

export default {
    name: 'KeysPanel',
    props: ['prjnum'],
    components: {
        AccessKey,
        KeyGeneration,
        DeletionModal
    },
    data (){
        return {
            loading: Boolean,
            loadError: false,
            keyData: [],
            validKeyData: [],
            expiredKeyData: []
        }
    },
    methods: {
        getKeyData(showLoadingIcon) {
            if (showLoadingIcon) this.loading = true;
            let url = '/api/v1/project/' + this.prjnum;

            axios.get(url)
            .then((response) => {
                this.keyData = response.data.keys;    
                this.validKeyData = this.keyData.filter(key => key.time_left > 0);
                this.expiredKeyData = this.keyData.filter(key => key.time_left <= 0);
                this.loading = false;
                this.loadError = false;  
            })
            .catch(error => {
                console.log(error.response.status, error.response.statusText);
                this.loading = false;
                this.loadError = true; 
            });
        },
        openKey(access_key) {
            this.$router.push('/projects/' + this.prjnum + '/keys/' + access_key);
        }
    },
    watch: {
        prjnum() {
            this.getKeyData(true);
        }
    },
    created() {
        this.getKeyData(true);
    },
    mounted() {
        this.emitter.on('expired-key-deleted', () => this.getKeyData(false));
    },
    beforeUnmount() {
        this.emitter.off('expired-key-deleted', () => this.getKeyData(false));
    }
}
</script>

<style scoped>

#keys-panel-text {
    padding: 0 1.5rem;
}
.key-container {
    clear: right;
    padding-top: 3rem;
}

.spaced {
    margin-top: 1rem;
    padding-bottom: 2.4rem;
}

@media screen and (max-width: 800px) {

    #keys-panel-text {
        padding: 0 1rem;
    }

}
</style>